import React, { forwardRef, useImperativeHandle, useState } from 'react';
import {Modal} from 'react-bootstrap';
import axios from '../../../interceptor/axios-config';
import FormUtility from '../Student/FormUtility';
import { useStudentsData } from '../../../context/StudentsContext';
import config from '../../../config';

const AttendanceModal = forwardRef((props, ref) => {

    const [modalBox, setModalBox] = useState(false);
    const [formData, setFormData] = useState({});
    const [canSave, setCanSave] = useState(false);
    const [err, SetErr] = useState('');
    const { studentsData } = useStudentsData();

   if(studentsData.messaage === 'No data yet'){
    SetErr('No UIDs Found!');
   }

    useImperativeHandle(ref, () => ({
        openModal() {
            setModalBox(true);            
        },  
    }));

    console.log(studentsData);
    console.log(err);
    
    const handleSubmit = (e) => {
        e.preventDefault(); 
        formData.forEach(data => {
            // axios.post('http://localhost/epro_API/api/students/newAttendance.php', data)
            axios.post(`${config.apiBaseUrl}/students/newAttendance.php`, data)
                .then(response => {
                console.log('Attendance added successfully', response);
                // Handle the response here if needed
                })
                .catch(error => {
                console.error('Error making POST request', error);
                // Handle the error here
                });
            });
            setCanSave(false);
            setFormData('')
    };

    const handleClose = (e) => {
        e.preventDefault();    
        setCanSave(false);
        setModalBox(false);
    };

  return (
    <>
        <Modal  onHide={setModalBox} size='xl' show={modalBox} centered>
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Attendance data scanner</h5>
                    <button type="button" className="btn-close"  onClick={handleClose}></button>
                </div>
                {err !== ''
                    ?{err}
                    :(<>
                        <div className="modal-body">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-12 col-lg-4 d-block">
                                    <div className="mb-3">
                                        <FormUtility 
                                            setFormData={setFormData} 
                                            setCanSave={setCanSave}
                                            canSave={canSave}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-success light" onClick={handleSubmit} disabled={canSave === false}>Save</button>
                        <button type="button" className="btn btn-danger light" onClick={handleClose}>Close</button>
                    </div>
                    </>
                    )
                } 
            </div>               
        </Modal>            
    </>
  )
})


export default AttendanceModal
